import React, { useState, useRef, useEffect } from "react";
import { Search, Filter, Check } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import Input from "../../../components/ui/Input";
import { Button } from "../../../components/ui/button";

const FILTER_OPTIONS = [
  { value: "TOUS", label: "Toutes les sociétés" },
  { value: "SAS", label: "SAS / SASU" },
  { value: "SARL", label: "SARL / EURL" },
  { value: "SCI", label: "SCI" },
  { value: "SPFPL", label: "SPFPL" },
  { value: "HOLDINGS", label: "Holdings" }
];

export default function SocieteSearch({
  search,
  setSearch,
  selectedForm = "TOUS",
  setSelectedForm
}) {
  const [isOpen, setIsOpen] = useState(false);
  const popoverRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (popoverRef.current && !popoverRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleKeyDown = (e) => {
    if (e.key === "Escape" && isOpen) {
      setIsOpen(false);
    }
  };

  const isFiltered = selectedForm && selectedForm !== "TOUS";
  const activeLabel = FILTER_OPTIONS.find((opt) => opt.value === selectedForm)?.label || "Filtrer";

  return (
    <div className="flex items-center gap-2 w-full sm:w-[320px] relative" onKeyDown={handleKeyDown}>
      <div className="relative w-full">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-subtle" />
        <Input
          type="text"
          placeholder="Rechercher une société..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="pl-9"
        />
      </div>

      <div className="relative" ref={popoverRef}>
        <Button
          variant={isFiltered ? "accent" : "secondary"}
          size="icon"
          onClick={() => setIsOpen(!isOpen)}
          title={`Filtre juridique : ${activeLabel}`}
        >
          <Filter className="w-4 h-4" />
        </Button>

        <AnimatePresence>
          {isOpen && (
            <motion.div
              initial={{ opacity: 0, y: 5, scale: 0.98 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: 5, scale: 0.98 }}
              transition={{ duration: 0.15 }}
              className="absolute right-0 mt-2 w-52 bg-surface rounded-[var(--hp-radius-md)] shadow-hp-md border border-workspace z-[100] py-1"
            >
              <div className="px-3 py-1.5 border-b border-workspace text-[11px] font-bold text-subtle uppercase tracking-wider">
                Forme juridique
              </div>
              <div className="py-1">
                {FILTER_OPTIONS.map((f) => (
                  <button
                    key={f.value}
                    type="button"
                    onClick={() => {
                      if (setSelectedForm) setSelectedForm(f.value);
                      setIsOpen(false);
                    }}
                    className={`w-full text-left px-4 py-2 text-sm flex items-center justify-between hover:bg-surface-muted transition-colors ${
                      selectedForm === f.value ? "text-primary font-semibold" : "text-muted"
                    }`}
                  >
                    <span>{f.label}</span>
                    {selectedForm === f.value && <Check className="w-4 h-4 text-primary" />}
                  </button>
                ))}
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
}
